import axios from "axios";
import { useEffect, useState } from "react";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

function ObtenerAdjuntos(props) {
  const [list2, setList2] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerAdjuntoAutoEvaluacion?SolicitudId=" +
        props.idInstitucionId +
        "&SubtituloId=" +
        props.Id,
    })
      .then((Response) => {
        setList2(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList2]);
  return (
    <>
      <div>
        {list2.map((item) => {
          return (
            <tr>
              •{" "}
              <button
                className="btn btn-success"
                onClick={() => descargarDocumento(item.urlUbicacion)}
              >
                Descargar
              </button>
            </tr>
          );
        })}
      </div>
    </>
  );
}
export default ObtenerAdjuntos;
